import React, { useEffect, useRef, useState } from "react";
//import "./productstable.css";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faPencil,
    faTrash,
    faEye,
} from "@fortawesome/free-solid-svg-icons";
import Pagination from "../../common/Pagination";
import { useDispatch, useSelector } from "react-redux";


import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Button from "@mui/material/Button";
import ApprovalTwoToneIcon from '@mui/icons-material/ApprovalTwoTone';
import BlockTwoToneIcon from '@mui/icons-material/BlockTwoTone';
import TimerTwoToneIcon from '@mui/icons-material/TimerTwoTone';
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import { useLocation } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, FormControlLabel, IconButton, Radio, RadioGroup, TextField } from "@mui/material";
import { DataGrid, GridApi, GridColDef, GridValueGetterParams, GridCellParams, gridClasses, GridColumnHeaderParams } from '@mui/x-data-grid';
import { CustomerService } from "../../service/customers.service";
import { alpha, styled } from '@mui/material/styles';
import AddCircleOutlineTwoToneIcon from '@mui/icons-material/AddCircleOutlineTwoTone';
import { forEach } from "lodash";
import { EnterpriseUsers } from "../../model/enterprise.model";

// dialog


import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import EnterpriseUserDialog from "../customers/enterprise/EnterpriseUserDialog";
import EnterpriseAccountDetails from "../customers/enterprise/EnterpriseAccountDetails";



//


// card 


//

function EnterpriseNotifications() {

    const customerService = new CustomerService();

    const [entAccountsData, setEntAccountsData] = useState<any[]>([]);

    //const [availableStatus, setAvailableStatus] = useState<OrderStatus[]>([]);

    const navigate = useNavigate();


    const [selectedEnt, setSelectedEnt] = useState<any>(null);

    const openUserListDialog = (bIndex: string, action: string) => {

        console.log("qqq : ", " : ", bIndex);

        /* navigate('../enterpriseAccountdetails',{state:{                   
            entDetails : entAccountsData[Number(bIndex)-1],
            //entData: finishesData ,
            action : action
        }}) */
        var entDetails =  bIndex; // entAccountsData[Number(bIndex) - 1];
      
       // console.log("userData :: --- " + entDetails.users)   
 
        //entDetails.users.forEach((userData: EnterpriseUsers, index1: any) => {
          //  console.log("userData" + userData.username)    
           // entUsers += userData.username + "(" + userData.mobileno + "),"
        //})

        setSelectedEnt(entDetails);

        setOpenUserList(true)

        console.log("aaaa ",selectedEnt)
    };


    const toEnterpriseAccountDetails = (bIndex: string, action: string) => {

        console.log("qqq : " + entAccountsData[Number(bIndex) - 1], " : ", bIndex);

        /* navigate('../enterpriseAccountdetails',{state:{                   
            entDetails : entAccountsData[Number(bIndex)-1],
            //entData: finishesData ,
            action : action
        }}) */
        var entDetails = entAccountsData[Number(bIndex) - 1];
        

        setSelectedEntDetails(entDetails)

        setOpen(true)
    };

    const [selectedEntDetails, setSelectedEntDetails] = useState("");

    // dialog 
   // const [status, setStatus] = useState(1);
   // const [enterpriseEIN, setEnterpriseEIN] = useState("");
   // const [enterpriseID, setEnterpriseID] = useState("");

    const [trigger, setTrigger] = useState(0);

    //



    const [open, setOpen] = React.useState(false);

    const [openUserist, setOpenUserList] = React.useState(false);

    /*
    "status": 0,
    "colorId": 1,
    "colorCode": "ZN",
    "colorDesc": "Zink"
    */

    const columns: GridColDef[] = [
        { field: 'id', headerName: 'Id', width: 70 },
        { field: 'ein', headerName: 'EIN', width: 100 },
        { field: 'name', headerName: 'Name', flex: 1 },
        { field: 'address', headerName: 'Address', flex: 1 },
        { field: 'branch', headerName: 'Branch', flex: 1 },
        { field: 'gst', headerName: 'GST', flex: 1 },
        { field: 'username', headerName: 'Username', flex: 1 },
        { field: 'mobileno', headerName: 'Mobile No.', flex: 1 },
        { field: 'email', headerName: 'MailId', flex: 1 },
        {
            field: 'statusColumn', headerName: 'User Status', flex: 1,
            renderCell: (params) => {
                return <div>
                    {params.value == 'Pending' && (<p style={{ color: "blue" }}>Pending</p>)
                        || params.value == 'Deactive' && (<p style={{ color: "red" }}>Deactive</p>)
                        || params.value == 'Active' && (<p style={{ color: "green" }}>Active</p>)
                    }
                </div>
            }
        },
        {
            field: 'entFeaturesColumn', headerName: 'Ent Feature', flex: 1,
            renderCell: (params) => {
                return <div>
                    {params.value == 'Pending' && (<p style={{ color: "blue" }}>Pending</p>)
                        || params.value == 'Deactive' && (<p style={{ color: "red" }}>Deactive</p>)
                        || params.value == 'Active' && (<p style={{ color: "green" }}>Active</p>)
                    }
                </div>
            }
        },
        { field: 'dateC', headerName: 'Created Date', flex: 1 },
        { field: 'dateU', headerName: 'Updated Date', flex: 1 },


        {
            field: "action",
            headerName: "Action",
            sortable: false,
            renderCell: (params) => {
                const onClick = (e: { stopPropagation: () => void; }) => {
                    e.stopPropagation(); // don't select this row after clicking

                    const api: GridApi = params.api;
                    const thisRow: Record<string, GridCellParams> = {};

                    api
                        .getAllColumns()
                        .filter((c: { field: string; }) => c.field !== "__check__" && !!c)
                        .forEach(
                            (c: { field: string | number; }) => (thisRow[c.field] = params.value.getValue(params.id, c.field))
                        );

                };

                return <div>
                    <Button onClick={(e) => toEnterpriseAccountDetails(params.value, "edit")} > <IconButton> <EditTwoToneIcon fontSize="small" /></IconButton></Button>

                </div>
            },
            flex: 1
        }

    ];

    const loadData = () => {

        customerService.enterpriseCustomerAccounts(-1).then(data => {
            const res = data.data;

            if (data.status != 100){
                setEntAccountsData([])
                return
            }

            //console.log('finishesData', res)
            let cnt1 = 0;
            const peopleWithImages = res.map((person: any, index: any) => {
                cnt1 = cnt1 + 1;

                var statusValue = "Pending"
                if (person.status == -1) {
                    statusValue = "Pending";
                } else     if (person.status == 0) {
                    statusValue = "Deactive";
                } else   if (person.status == 1) {
                    statusValue = "Active";
                }

                
                var entFeaturesColumn = "Pending"
                if (person.entFeatures == -1) {
                    entFeaturesColumn = "Pending";
                } else     if (person.entFeatures == 0) {
                    entFeaturesColumn = "Deactive";
                } else   if (person.entFeatures == 1) {
                    entFeaturesColumn = "Active";
                }

                


                return {
                    ...person,
                    id: person.entId,
                    ein: person.EIN,
                    name: person.entName,
                    address: person.entAddress,
                    branch: person.entBranch,
                    gst: person.entGST,
                    statusColumn: statusValue,
                    status: person.status,
                    entFeaturesColumn : entFeaturesColumn,
                    // users: entUsers,
                 //   users: userdata ,
                    dateC: person.DateC,
                    dateU: person.DateU,
                    action: cnt1,

                };

            });
            setEntAccountsData(peopleWithImages)


        });

    }

    let isLoadDataInit = false;
    useEffect(() => {

        if (!isLoadDataInit) {
            isLoadDataInit = true;
            loadData();
        }

    }, [])


    // dialog 

    const handleUserDialogCallBack = () => {
        setOpenUserList(false)
        loadData()
    }

    const handleCallBack = () => {

        setOpen(false);
        loadData();

       /* toast.success("Updated Successfully !!!", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 2000,
            hideProgressBar: true,
          }); */        
    };

    const ref = useRef();

    const savedata = () => {
        console.log("pooooooo")
        //setTrigger(78)

    };

    const handleListClose = () => {
      //  console.log("opppppppppppppppppppppppppppppppppp")
        setOpenUserList(false)
    };


    const handleClose = () => {
      //  console.log("opppppppppppppppppppppppppppppppppp")
        setOpen(false);
    };

    const BootstrapDialog = styled(Dialog)(({ theme }) => ({
        '& .MuiDialogContent-root': {
            padding: theme.spacing(2),
        },
        '& .MuiDialogActions-root': {
            padding: theme.spacing(1),
        },
    }));

    interface DialogTitleProps {
        id: string;
        children?: React.ReactNode;
        onClose: () => void;
    }

    function BootstrapDialogTitle(props: DialogTitleProps) {
        const { children, onClose, ...other } = props;

        return (
            <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
                {children}
                {onClose ? (
                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                ) : null}
            </DialogTitle>
        );
    }


    ///


    return (

        <>
            <div >
                <div className="App border card">
                    


                    <div style={{ width: '100%' }}>
                        <DataGrid

                            // table customization start
                            sx={{
                                '& .MuiDataGrid-columnHeaderTitle': {
                                    whiteSpace: "break-spaces", lineHeight: 1, fontSize: "13px", fontWeight: "bold",
                                },
                                '& .MuiDataGrid-columnHeader': {
                                    backgroundColor: "#D0D0D0"
                                },
                                '& .Mui-odd': {
                                    textOverflow: "inherit", fontSize: "12px", textAlign: "left"
                                },

                                '& .Mui-even': {
                                    backgroundColor: "#F7f7f7", textOverflow: "inherit", fontSize: "12px", textAlign: "left"

                                },

                                '& .Mui-cellown': {
                                    paddingTop: 0, paddingBottom: 0

                                },

                            }}

                            getCellClassName={(params) => 'Mui-cellown'}
                            getRowClassName={(params) =>
                                params.indexRelativeToCurrentPage % 2 === 0 ? 'Mui-even' : 'Mui-odd'}
                            autoHeight={true}
                            getRowHeight={() => 'auto'}

                            // table customization


                            rows={entAccountsData}
                            columns={columns}

                            initialState={{
                                pagination: {
                                    paginationModel: { page: 0, pageSize: 5 },
                                },
                            }}
                            pageSizeOptions={[5,10, 25]}

                        />
                    </div>


                </div>


                <BootstrapDialog
                    fullWidth                    
                    onClose={handleListClose}
                    aria-labelledby="customized-dialog-title"
                    open={openUserist}>

                    <BootstrapDialogTitle id="customized-dialog-title" onClose={handleListClose}>
                        User List
                    </BootstrapDialogTitle>

                    <EnterpriseUserDialog  entDetails={selectedEnt}  callback={handleUserDialogCallBack} ></EnterpriseUserDialog>

                    <DialogActions>
                   
                    </DialogActions>
                </BootstrapDialog>


                <BootstrapDialog
                    fullWidth
                    onClose={handleClose}
                    aria-labelledby="customized-dialog-title"
                    open={open}>

                    <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
                        Enterprise Status
                    </BootstrapDialogTitle>

                    <EnterpriseAccountDetails entDetail={selectedEntDetails}  hideEntFeature={false}   callback={handleCallBack} ></EnterpriseAccountDetails>

                    <DialogActions>
                   
                    </DialogActions>
                </BootstrapDialog>
                <ToastContainer />
            </div>
        </>

    );
}


export default EnterpriseNotifications;
